import React from "react";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { RiLoginCircleFill } from "react-icons/ri";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="py-16 md:py-24 bg-white overflow-x-clip relative">
      {/* Gradient Background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-200 to-orange-300 blur-[100px]"></div>
        <div className="absolute inset-0 bg-gradient-to-br from-amber-300 to-yellow-200 blur-[100px] opacity-50"></div>
      </div>

      <div className="relative max-w-screen-xl mx-auto px-4">
        <div className="w-full flex flex-col md:flex-row gap-4 items-center z-10 relative">
          {/* Content Section */}
          <div className="flex-1 min-w-0">
            <h1 className="text-5xl md:text-6xl font-bold mb-4 whitespace-normal">
              Welcome to <span className="text-yellow-500">intelleX CLMS</span>{" "}
              Contract Life Cycle Management System
            </h1>

            <p className="text-lg md:text-xl text-gray-700 leading-8 mb-8 text-wrap">
              Manage your contracts effortlessly with our user-friendly system.
              Save time, boost efficiency, and say goodbye to frustration.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 items-center">
              <Link
                to="/login"
                className="bg-yellow-500 hover:bg-yellow-600 text-white flex items-center justify-center gap-2 h-12 px-6 rounded cursor-pointer w-full sm:w-auto"
              >
                <RiLoginCircleFill className="h-6 w-6" />
                Get Started
              </Link>
              <Link
                to="/tenant-manager"
                className="border border-gray-300 bg-white hover:bg-gray-100 text-gray-800 flex items-center justify-center gap-2 h-12 px-6 rounded cursor-pointer w-full sm:w-auto"
              >
                <BsFillInfoCircleFill className="h-6 w-6" />
                Learn More
              </Link>
            </div>
          </div>
          {/* Image Section */}
          <div className="flex-1 min-w-0 mt-4">
            <img
              src="image/intellex2.png"
              alt="System preview"
              className="object-contain mx-auto h-[440px] w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
